import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubDepartment } from '../models/subdepartment';

@Injectable({
  providedIn: 'root'
})
export class SubDepartmentService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'subdepartment/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllSubDepartment(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllSubDepartments?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewSubDepartment(SubDepartmentID?: string): Observable<Array<SubDepartment>> {
      return this.httpService.get(this.apiEndpoint + '/viewSubDepartment/' + (SubDepartmentID ? SubDepartmentID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveSubDepartment(subdepartments: SubDepartment): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveSubDepartment/', subdepartments).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteSubDepartment(SubDepartmentID?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteSubDepartment/' + (SubDepartmentID ? SubDepartmentID : '00000000-0000-0000-0000-000000000000'), SubDepartmentID).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(SubDepartmentID?: string,SubDepartmentPrefix?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?&SubDepartmentID=' + (SubDepartmentID ? SubDepartmentID : '00000000-0000-0000-0000-000000000000')+'&SubDepartmentPrefix=' + (SubDepartmentPrefix ? SubDepartmentPrefix : '')).pipe(map((result: any) => {
          return result; 
      }));
    }  
  }

